<template>
    <g-column :span="12">
        <campaign-list-item v-if="campaign" :campaign="campaign" />
        <activation-list-item v-else-if="activation" type="activation" :object="activation" :hasReocurringProposals="hasReocurringProposals" />
        <activation-list-item v-else-if="brief" type="activation_brief" :object="brief" :hasReocurringProposals="hasReocurringProposals" />
    </g-column>
</template>

<script>
    import CampaignListItem from './CampaignListItem.vue';
    import ActivationListItem from './ActivationListItem.vue';

    export default {
        name: 'SponsorshipListItem',

        components: {
            CampaignListItem,
            ActivationListItem
        },

        props: {
            brief: {
                type: Object,
                default: null
            },
            activation: {
                type: Object,
                default: null
            },
            campaign: {
                type: Object,
                default: null
            },
            hasReocurringProposals: {
                type: Boolean,
                default: false,
                required: false
            }
        }
    };
</script>
